// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"a96db49f","375":"388034b9","513":"e584d4b1","813":"388034b9"}[chunkId] + ".chunk.css";
};